module.exports = __webpack_public_path__ + "img/app5.8b556633.png";